export const rollMaterialStats = () => {
  const roll1d100 = () => Math.floor(Math.random() * 100) + 1;

  const rarityRoll = roll1d100();
  const qualityRoll = roll1d100();

  let rarity = "Common";
  if (rarityRoll === 1) rarity = "Celestial";
  else if (rarityRoll >= 2 && rarityRoll <= 5) rarity = "Legendary";
  else if (rarityRoll >= 6 && rarityRoll <= 20) rarity = "Rare";
  else if (rarityRoll >= 21 && rarityRoll <= 50) rarity = "Uncommon";

  let quality = "Good";
  if (qualityRoll === 1) quality = "Impeccable";
  else if (qualityRoll >= 2 && qualityRoll <= 5) quality = "Finest";
  else if (qualityRoll >= 6 && qualityRoll <= 35) quality = "Reliable";
  else if (qualityRoll >= 86) quality = "Poor";

  return { rarityRoll, rarity, qualityRoll, quality };
};
